// Liste des tous les events MAIN de l'appli
export const EVENTS_MAIN_TYPE_SERVICE = 'SERVICE'
export const EVENTS_MAIN_TYPE_CIRCUIT = 'CIRCUIT'
export const EVENTS_MAIN_TYPE_SERVICE_BREAK = 'SERVICE_BREAK'
export const EVENTS_MAIN_TYPE_SERVICE_ROUND = 'SERVICE_ROUND'
export const EVENTS_MAIN_TYPE_CHECKPOINT = 'CHECKPOINT'
export const EVENTS_MAIN_TYPE_AGENT = 'AGENT'
export const EVENTS_MAIN_TYPE_INCIDENT = 'INCIDENT'
export const EVENTS_MAIN_TYPE_OBSERVATION = 'OBSERVATION'
export const EVENTS_MAIN_TYPE_SPECIFIC_CONTROL = 'SPECIFIC_CONTROL'
export const EVENTS_MAIN_TYPE_PRESENCE = 'PRESENCE'
export const EVENTS_MAIN_TYPE_LOGISTIC = 'LOGISTIC'
export const EVENTS_MAIN_TYPE_CARE_RESCUE = 'CARE_RESCUE'
export const EVENTS_MAIN_TYPE_DELIVERY = 'DELIVERY'

export const MAIN_TYPE_SERVICE = {
  id: 1,
  typeKey: EVENTS_MAIN_TYPE_SERVICE,
  name: 'Services',
  icon: '',
  color: ''
}
export const MAIN_TYPE_CIRCUIT = {
  id: 2,
  typeKey: EVENTS_MAIN_TYPE_CIRCUIT,
  name: 'Tournées',
  icon: '',
  color: ''
}
export const MAIN_TYPE_SERVICE_BREAK = {
  id: 3,
  typeKey: EVENTS_MAIN_TYPE_SERVICE_BREAK,
  name: 'Pauses',
  icon: '',
  color: ''
}
export const MAIN_TYPE_SERVICE_ROUND = {
  id: 4,
  typeKey: EVENTS_MAIN_TYPE_SERVICE_ROUND,
  name: 'Rondes',
  icon: '',
  color: ''
}
export const MAIN_TYPE_CHECKPOINT = {
  id: 5,
  typeKey: EVENTS_MAIN_TYPE_CHECKPOINT,
  name: 'Points de contrôle',
  icon: 'fa fa-map-marker',
  color: ''
}
export const MAIN_TYPE_AGENT = {
  id: 6,
  typeKey: EVENTS_MAIN_TYPE_AGENT,
  name: 'Agents',
  icon: 'fa fa-user-shield',
  color: ''
}
export const MAIN_TYPE_INCIDENT = {
  id: 7,
  typeKey: EVENTS_MAIN_TYPE_INCIDENT,
  name: 'Incidents',
  icon: 'fa fa-exclamation-triangle',
  color: ''
}
export const MAIN_TYPE_OBSERVATION = {
  id: 8,
  typeKey: EVENTS_MAIN_TYPE_OBSERVATION,
  name: 'Observations',
  icon: '',
  color: ''
}
export const MAIN_TYPE_SPECIFIC_CONTROL = {
  id: 9,
  typeKey: EVENTS_MAIN_TYPE_SPECIFIC_CONTROL,
  name: 'Contrôles spécifiques',
  icon: 'fa fa-search',
  color: ''
}
export const MAIN_TYPE_PRESENCE = {
  id: 10,
  typeKey: EVENTS_MAIN_TYPE_PRESENCE,
  name: 'Présences',
  icon: 'fa fa-user',
  color: ''
}
export const MAIN_TYPE_LOGISTIC = {
  id: 11,
  typeKey: EVENTS_MAIN_TYPE_LOGISTIC,
  name: 'Logistiques',
  icon: 'fa fa-dolly',
  color: ''
}
export const MAIN_TYPE_CARE_RESCUE = {
  id: 12,
  typeKey: EVENTS_MAIN_TYPE_CARE_RESCUE,
  name: 'Soins et secours',
  icon: 'fa fa-first-aid',
  color: ''
}
export const MAIN_TYPE_DELIVERY = {
  id: 13,
  typeKey: EVENTS_MAIN_TYPE_DELIVERY,
  name: 'Livraisons',
  icon: 'fa fa-truck-loading'
}

/**
 * Glossaire évènements (services)
 * @type {{typeKey: string, color: string, defaultValue: {customerShow: boolean, notifyCustomer: boolean, notifyAgency: boolean, enabled: boolean}, name: string, icon: string, id: number}}
 */
export const TYPE_SERVICE_START = {
  id: 30,
  typeKey: 'SERVICE_START',
  name: 'Début de service',
  icon: 'fa fa-user-shield',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_START_LATE = {
  id: 31,
  typeKey: 'SERVICE_START_LATE',
  name: 'Début de service en retard',
  icon: 'fa fa-user-shield',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_LATE = {
  id: 32,
  typeKey: 'SERVICE_LATE',
  name: 'Service non débuté',
  icon: 'fa fa-user-shield',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_RESUME = {
  id: 33,
  typeKey: 'SERVICE_RESUME',
  name: 'Reprise de service',
  icon: 'fa fa-user-shield',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_INTERRUPTED = {
  id: 34,
  typeKey: 'SERVICE_INTERRUPTED',
  name: 'Interruption de service',
  icon: 'fa fa-user-shield',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_STOPPED = {
  id: 35,
  typeKey: 'SERVICE_STOPPED',
  name: 'Fin de service anticipée',
  icon: 'fa fa-user-shield',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_FINISH = {
  id: 36,
  typeKey: 'SERVICE_FINISH',
  name: 'Fin de service',
  icon: 'fa fa-user-shield',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Glossaire évènements (tournées)
 * @type {{typeKey: string, color: string, defaultValue: {customerShow: boolean, notifyCustomer: boolean, notifyAgency: boolean, enabled: boolean}, name: string, icon: string, id: number}}
 */
export const TYPE_CIRCUIT_START = {
  id: 37,
  typeKey: 'CIRCUIT_START',
  name: 'Début de tournée',
  icon: 'fa fa-user-shield',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_CIRCUIT_START_LATE = {
  id: 38,
  typeKey: 'CIRCUIT_START_LATE',
  name: 'Retard de début de tournée',
  icon: 'fa fa-user-shield',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_CIRCUIT_LATE = {
  id: 39,
  typeKey: 'CIRCUIT_LATE',
  name: 'Tournée non débutée',
  icon: 'fa fa-user-shield',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_CIRCUIT_RESUME = {
  id: 40,
  typeKey: 'CIRCUIT_RESUME',
  name: 'Reprise de tournée',
  icon: 'fa fa-user-shield',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_CIRCUIT_INTERRUPTED = {
  id: 41,
  typeKey: 'CIRCUIT_INTERRUPTED',
  name: 'Interruption de tournée',
  icon: 'fa fa-user-shield',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_CIRCUIT_STOPPED = {
  id: 42,
  typeKey: 'CIRCUIT_STOPPED',
  name: 'Fin de tournée anticipée',
  icon: 'fa fa-user-shield',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_CIRCUIT_FINISH = {
  id: 43,
  typeKey: 'CIRCUIT_FINISH',
  name: 'Fin de tournée',
  icon: 'fa fa-user-shield',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Glossaire évènements (pauses)
 * @type {{typeKey: string, defaultValue: {customerShow: boolean, notifyCustomer: boolean, notifyAgency: boolean, enabled: boolean}, name: string, icon: string, id: number}}
 */
export const TYPE_SERVICE_BREAK_START = {
  id: 44,
  typeKey: 'SERVICE_BREAK_START',
  name: 'Début de pause',
  icon: 'fa fa-coffee',
  color: '',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
/** @deprecated use TYPE_SERVICE_BREAK_RESUME */
export const TYPE_SERVICE_BREAK_RESTART = {
  typeKey: 'SERVICE_BREAK_RESTART',
  name: 'Reprise pause',
  icon: 'fa fa-coffee',
  color: '',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_BREAK_RESUME = {
  id: 45,
  typeKey: 'SERVICE_BREAK_RESUME',
  name: 'Reprise de pause',
  icon: 'fa fa-coffee',
  color: '',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_BREAK_INTERRUPTED = {
  id: 46,
  typeKey: 'SERVICE_BREAK_INTERRUPTED',
  name: 'Interruption de pause',
  icon: 'fa fa-coffee',
  color: '',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: false,
    notifyCustomer: false
  }
}
/** @deprecated use TYPE_SERVICE_BREAK_FINISH */
export const TYPE_SERVICE_BREAK_STOP = {
  typeKey: 'SERVICE_BREAK_STOP',
  name: 'Pause terminée',
  icon: 'fa fa-coffee',
  color: '',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_BREAK_FINISH = {
  id: 47,
  typeKey: 'SERVICE_BREAK_FINISH',
  name: 'Fin de pause',
  icon: 'fa fa-coffee',
  color: '',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
/** @deprecated use TYPE_SERVICE_FINISH */
export const TYPE_SERVICE_STOP = {
  typeKey: 'SERVICE_STOP',
  name: 'Service stoppé',
  icon: 'fa fa-user-shield',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}

/**
 * Glossaire évènements (rondes)
 * @type {{typeKey: string, color: string, defaultValue: {customerShow: boolean, notifyCustomer: boolean, notifyAgency: boolean, enabled: boolean}, name: string, icon: string, id: number}}
 */
export const TYPE_SERVICE_ROUND_START = {
  id: 48,
  typeKey: 'SERVICE_ROUND_START',
  name: 'Début de ronde',
  icon: 'fas fa-route',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_ROUND_RESUME = {
  id: 49,
  typeKey: 'SERVICE_ROUND_RESUME',
  name: 'Reprise de ronde',
  icon: 'fas fa-route',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
/** @deprecated use TYPE_SERVICE_ROUND_INTERUPTED */
export const TYPE_SERVICE_ROUND_STOP = {
  typeKey: 'SERVICE_ROUND_STOP',
  name: 'Ronde stoppée',
  icon: 'fas fa-route',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_ROUND_INTERRUPTED = {
  id: 50,
  typeKey: 'SERVICE_ROUND_INTERRUPTED',
  name: 'Interruption de ronde',
  icon: 'fas fa-route',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_ROUND_FINISH = {
  id: 51,
  typeKey: 'SERVICE_ROUND_FINISH',
  name: 'Fin de ronde',
  icon: 'fas fa-flag-checkered',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_SERVICE_ROUND_NOT_REALIZED = {
  id: 134,
  typeKey: 'SERVICE_ROUND_NOT_REALIZED',
  name: 'Ronde non réalisée',
  icon: 'fas fa-eye-slash',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Glossaire évènements (points de contrôle)
 * @type {{typeKey: string, color: string, defaultValue: {customerShow: boolean, notifyCustomer: boolean, notifyAgency: boolean, enabled: boolean}, name: string, icon: string, id: number}}
 */
export const TYPE_CHECKPOINT_VALIDATED = {
  id: 52,
  typeKey: 'CHECKPOINT_VALIDATED',
  name: 'Validation point de contrôle',
  icon: 'fa fa-check',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_CHECKPOINT_GEOLOCATED = {
  id: 53,
  typeKey: 'CHECKPOINT_GEOLOCATED',
  name: 'Point de contrôle géolocalisé',
  icon: 'fas fa-map-marker-alt',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_CHECKPOINT_JUMP = {
  id: 54,
  typeKey: 'CHECKPOINT_JUMP',
  name: 'Point de contrôle sauté',
  icon: 'fa fa-forward',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const TYPE_CHECKPOINT_MOVED = {
  id: 55,
  typeKey: 'CHECKPOINT_MOVED',
  name: 'Point de contrôle déplacé',
  icon: 'fas fa-tasks',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}

/**
 * Glossaire évènements (agents)
 * @type {{typeKey: string, color: string, defaultValue: {customerShow: boolean, notifyCustomer: boolean, notifyAgency: boolean, enabled: boolean}, name: string, icon: string, id: number}}
 */
export const TYPE_AGENT_EMERGENCY_CALL = {
  id: 56,
  typeKey: 'AGENT_EMERGENCY_CALL',
  name: 'Appel d\'urgence',
  icon: 'fa fa-phone',
  color: 'negative',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_AGENT_SOS_ALERT = {
  id: 57,
  typeKey: 'AGENT_SOS_ALERT',
  name: 'Alerte agent renfort',
  icon: 'fa fa-comment',
  color: '',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_AGENT_INACTIVE = {
  id: 58,
  typeKey: 'AGENT_INACTIVE',
  name: 'Agent inactif',
  icon: 'fa fa-bed',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_AGENT_FALL = {
  id: 59,
  typeKey: 'AGENT_FALL',
  name: 'Chute de l\'agent',
  icon: 'fa fa-walking fa-rotate-270',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_AGENT_LEAVE_PREMISES = {
  id: 60,
  typeKey: 'AGENT_LEAVE_PREMISES',
  name: 'Sortie de périmètre',
  icon: 'fa fa-sign-out-alt',
  color: 'warning',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}
export const TYPE_AGENT_RETURN = {
  id: 61,
  typeKey: 'AGENT_RETURN',
  name: 'Retour dans le périmètre',
  icon: 'fa fa-sign-in-alt',
  color: 'positive',
  defaultValue: {
    enabled: true,
    customerShow: false,
    notifyAgency: true,
    notifyCustomer: false
  }
}

export const TYPE_OBSERVATION_DEFAULT = {
  id: 86,
  typeKey: 'OBSERVATION_DEFAULT',
  name: 'Observation',
  icon: 'fa fa-comment-alt',
  color: 'neutral',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Liste des évents
 */
export const LISTE_TYPE_EVENTS = [
  MAIN_TYPE_SERVICE,
  MAIN_TYPE_CIRCUIT,
  MAIN_TYPE_SERVICE_BREAK,
  MAIN_TYPE_SERVICE_ROUND,
  MAIN_TYPE_CHECKPOINT,
  MAIN_TYPE_AGENT,
  MAIN_TYPE_INCIDENT,
  MAIN_TYPE_OBSERVATION,
  MAIN_TYPE_SPECIFIC_CONTROL,
  MAIN_TYPE_PRESENCE,
  MAIN_TYPE_LOGISTIC,
  MAIN_TYPE_CARE_RESCUE,
  MAIN_TYPE_DELIVERY,
  TYPE_SERVICE_START,
  TYPE_SERVICE_START_LATE,
  TYPE_SERVICE_LATE,
  TYPE_SERVICE_RESUME,
  TYPE_SERVICE_INTERRUPTED,
  TYPE_SERVICE_STOPPED,
  TYPE_SERVICE_FINISH,
  TYPE_CIRCUIT_START,
  TYPE_CIRCUIT_START_LATE,
  TYPE_CIRCUIT_LATE,
  TYPE_CIRCUIT_RESUME,
  TYPE_CIRCUIT_INTERRUPTED,
  TYPE_CIRCUIT_STOPPED,
  TYPE_CIRCUIT_FINISH,
  TYPE_SERVICE_BREAK_START,
  TYPE_SERVICE_BREAK_RESUME,
  TYPE_SERVICE_BREAK_RESTART,
  TYPE_SERVICE_BREAK_INTERRUPTED,
  TYPE_SERVICE_BREAK_FINISH,
  TYPE_SERVICE_BREAK_STOP,
  TYPE_SERVICE_BREAK_FINISH,
  TYPE_SERVICE_FINISH,
  TYPE_SERVICE_STOP,
  TYPE_SERVICE_ROUND_START,
  TYPE_SERVICE_ROUND_RESUME,
  TYPE_SERVICE_ROUND_STOP,
  TYPE_SERVICE_ROUND_INTERRUPTED,
  TYPE_SERVICE_ROUND_FINISH,
  TYPE_SERVICE_ROUND_NOT_REALIZED,
  TYPE_CHECKPOINT_VALIDATED,
  TYPE_CHECKPOINT_GEOLOCATED,
  TYPE_CHECKPOINT_JUMP,
  TYPE_CHECKPOINT_MOVED,
  TYPE_AGENT_EMERGENCY_CALL,
  TYPE_AGENT_SOS_ALERT,
  TYPE_AGENT_INACTIVE,
  TYPE_AGENT_FALL,
  TYPE_AGENT_LEAVE_PREMISES,
  TYPE_AGENT_RETURN,
  TYPE_OBSERVATION_DEFAULT
]

export const INDEXED_ALL_EVENTS = _.keyBy(LISTE_TYPE_EVENTS, 'typeKey')

/**
 * Glossaire des évènements incidents
 * @type {{name: string, typeKey: string}}
 */
export const EVENT_INCIDENT_FREE_ENTRY = {
  id: 62,
  typeKey: 'INCIDENT_FREE_ENTRY',
  name: 'Entrée libre',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_ALARM_TRIGGERED = {
  id: 63,
  typeKey: 'INCIDENT_ALARM_TRIGGERED',
  name: 'Alarme déclenchée',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_STONING = {
  id: 64,
  typeKey: 'INCIDENT_STONING',
  name: 'Jet de pierres',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_INTRUSION = {
  id: 65,
  typeKey: 'INCIDENT_INTRUSION',
  name: 'Intrusion',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_BREAKING_IN = {
  id: 66,
  typeKey: 'INCIDENT_BREAKING_IN',
  name: 'Effraction',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_HARDWARE_STATE = {
  id: 67,
  typeKey: 'INCIDENT_HARDWARE_STATE',
  name: 'Problème informatique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_AGENT_ATTACK = {
  id: 68,
  typeKey: 'INCIDENT_AGENT_ATTACK',
  name: 'Attaque sur agent',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_PHYSICAL_AGGRESSION = {
  id: 69,
  typeKey: 'INCIDENT_PHYSICAL_AGGRESSION',
  name: 'Agression physique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_THEFT = {
  id: 70,
  typeKey: 'INCIDENT_THEFT',
  name: 'Vol',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_FRAUD = {
  id: 71,
  typeKey: 'INCIDENT_FRAUD',
  name: 'Fraude',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_VERBAL_AGGRESSION = {
  id: 72,
  typeKey: 'INCIDENT_VERBAL_AGGRESSION',
  name: 'Agression verbale',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_INCIVILITY = {
  id: 73,
  typeKey: 'INCIDENT_INCIVILITY',
  name: 'Incivilité',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_BURNING = {
  id: 74,
  typeKey: 'INCIDENT_BURNING',
  name: 'Incendie',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_MATERIAL = {
  id: 75,
  typeKey: 'INCIDENT_MATERIAL',
  name: 'Matériel',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_WATER_DAMAGED = {
  id: 76,
  typeKey: 'INCIDENT_WATER_DAMAGED',
  name: 'Dégâts des eaux',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_ACCIDENT = {
  id: 77,
  typeKey: 'INCIDENT_ACCIDENT',
  name: 'Accident',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_ELECTRICAL_FAILURE = {
  id: 78,
  typeKey: 'INCIDENT_ELECTRICAL_FAILURE',
  name: 'Problème électrique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_HEART_DISEASE = {
  id: 79,
  typeKey: 'INCIDENT_HEART_DISEASE',
  name: 'Malaise cardiaque',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_UNCONSCIOUS = {
  id: 80,
  typeKey: 'INCIDENT_UNCONSCIOUS',
  name: 'Perte de connaissance',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_BURN = {
  id: 81,
  typeKey: 'INCIDENT_BURN',
  name: 'Brûlure',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_BLEEDING = {
  id: 82,
  typeKey: 'INCIDENT_BLEEDING',
  name: 'Saignement',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_FALL = {
  id: 83,
  typeKey: 'INCIDENT_FALL',
  name: 'Chute',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_CHOKING = {
  id: 84,
  typeKey: 'INCIDENT_CHOKING',
  name: 'Etouffement',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}
export const EVENT_INCIDENT_OTHER = {
  id: 85,
  typeKey: 'INCIDENT_OTHER',
  name: 'Autre incident',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: true,
    notifyCustomer: true
  }
}

/**
 * Glossaire des évènements de contrôles spécifiques
 * @type {{name: string, typeKey: string}}
 */
export const EVENT_SPECIFIC_CONTROL_DOOR = {
  id: 87,
  typeKey: 'SPECIFIC_CONTROL_DOOR',
  name: 'Contrôle porte',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_PORTAL = {
  id: 88,
  typeKey: 'SPECIFIC_CONTROL_PORTAL',
  name: 'Contrôle portail',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_FENCING = {
  id: 89,
  typeKey: 'SPECIFIC_CONTROL_FENCING',
  name: 'Contrôle clôture',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_WINDOW = {
  id: 90,
  typeKey: 'SPECIFIC_CONTROL_WINDOW',
  name: 'Contrôle fenêtre',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_TEMPERATURE = {
  id: 91,
  typeKey: 'SPECIFIC_CONTROL_TEMPERATURE',
  name: 'Contrôle température',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_MATERIAL = {
  id: 92,
  typeKey: 'SPECIFIC_CONTROL_MATERIAL',
  name: 'Contrôle matériel',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_ELECTRIC = {
  id: 93,
  typeKey: 'SPECIFIC_CONTROL_ELECTRIC',
  name: 'Contrôle électrique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_EXTINGUISHER = {
  id: 94,
  typeKey: 'SPECIFIC_CONTROL_EXTINGUISHER',
  name: 'Contrôle extincteur',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_MACHINE = {
  id: 95,
  typeKey: 'SPECIFIC_CONTROL_MACHINE',
  name: 'Contrôle machine',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_SHOWCASE = {
  id: 96,
  typeKey: 'SPECIFIC_CONTROL_SHOWCASE',
  name: 'Contrôle vitrine',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_VEHICLE = {
  id: 97,
  typeKey: 'SPECIFIC_CONTROL_VEHICLE',
  name: 'Contrôle véhicule',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_CHECKOUT = {
  id: 98,
  typeKey: 'SPECIFIC_CONTROL_CHECKOUT',
  name: 'Contrôle caisse enregistreuse',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_PEOPLE = {
  id: 99,
  typeKey: 'SPECIFIC_CONTROL_PEOPLE',
  name: 'Contrôle de personnes',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_ROOM = {
  id: 100,
  typeKey: 'SPECIFIC_CONTROL_ROOM',
  name: 'Contrôle pièce',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_FLOOR = {
  id: 101,
  typeKey: 'SPECIFIC_CONTROL_FLOOR',
  name: 'Contrôle sol',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_BUILDING = {
  id: 102,
  typeKey: 'SPECIFIC_CONTROL_BUILDING',
  name: 'Contrôle bâtiment',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_EXTERIOR = {
  id: 103,
  typeKey: 'SPECIFIC_CONTROL_EXTERIOR',
  name: 'Contrôle extérieur',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_ENTRY = {
  id: 104,
  typeKey: 'SPECIFIC_CONTROL_ENTRY',
  name: 'Contrôle entrée',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_EXIT = {
  id: 105,
  typeKey: 'SPECIFIC_CONTROL_EXIT',
  name: 'Contrôle sortie',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_STOCK = {
  id: 106,
  typeKey: 'SPECIFIC_CONTROL_STOCK',
  name: 'Contrôle stock',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_SPECIFIC_CONTROL_OTHER = {
  id: 107,
  typeKey: 'SPECIFIC_CONTROL_OTHER',
  name: 'Autre contrôle',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Glossaire des évènements de présences
 * @type {{name: string, typeKey: string}}
 */
export const EVENT_PRESENCE_ENTRY = {
  id: 108,
  typeKey: 'PRESENCE_ENTRY',
  name: 'Présence sortie',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_PRESENCE_EXIT = {
  id: 109,
  typeKey: 'PRESENCE_EXIT',
  name: 'Présence entrée',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_PRESENCE_ON_SITE = {
  id: 110,
  typeKey: 'PRESENCE_ON_SITE',
  name: 'Présence site',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_PRESENCE_OTHER = {
  id: 111,
  typeKey: 'PRESENCE_OTHER',
  name: 'Autre présence',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Glossaire des évènements de logistique
 * @type {{name: string, typeKey: string}}
 */
export const EVENT_LOGISTIC_MERCHANDISES_ENTRY = {
  id: 112,
  typeKey: 'LOGISTIC_MERCHANDISES_ENTRY',
  name: 'Entrée de marchandise',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_MERCHANDISES_EXIT = {
  id: 113,
  typeKey: 'LOGISTIC_MERCHANDISES_EXIT',
  name: 'Sortie de marchandise',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_KEY = {
  id: 114,
  typeKey: 'LOGISTIC_KEY',
  name: 'Clé logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_BADGE = {
  id: 115,
  typeKey: 'LOGISTIC_BADGE',
  name: 'Badge logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_LOSS = {
  id: 116,
  typeKey: 'LOGISTIC_LOSS',
  name: 'Perte logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_THEFT = {
  id: 117,
  typeKey: 'LOGISTIC_THEFT',
  name: 'Vol logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_VEHICLE = {
  id: 118,
  typeKey: 'LOGISTIC_VEHICLE',
  name: 'Véhicule logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_CLOTHING = {
  id: 119,
  typeKey: 'LOGISTIC_CLOTHING',
  name: 'Vêtements logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_TOOLS = {
  id: 120,
  typeKey: 'LOGISTIC_TOOLS',
  name: 'Outils logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_LOGISTIC_OTHER = {
  id: 121,
  typeKey: 'LOGISTIC_OTHER',
  name: 'Autre logistique',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Glossaire des évènements soins et secours
 * @type {{name: string, typeKey: string}}
 */
export const EVENT_CARE_RESCUE_POLICE = {
  id: 122,
  typeKey: 'CARE_RESCUE_POLICE',
  name: 'Police',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_CARE_RESCUE_FIREFIGHTER = {
  id: 123,
  typeKey: 'CARE_RESCUE_FIREFIGHTER',
  name: 'Pompier',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_CARE_RESCUE_GENDARME = {
  id: 124,
  typeKey: 'CARE_RESCUE_GENDARME',
  name: 'Gendarme',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_CARE_RESCUE_AMBULANCE = {
  id: 125,
  typeKey: 'CARE_RESCUE_AMBULANCE',
  name: 'SAMU',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_CARE_RESCUE_DOCTOR = {
  id: 126,
  typeKey: 'CARE_RESCUE_DOCTOR',
  name: 'SOS Medecins',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_CARE_RESCUE_REINFORCEMENT = {
  id: 127,
  typeKey: 'CARE_RESCUE_REINFORCEMENT',
  name: 'Renforts',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_CARE_RESCUE_FIRST_AID = {
  id: 128,
  typeKey: 'CARE_RESCUE_FIRST_AID',
  name: 'Premiers soins',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_CARE_RESCUE_OTHER = {
  id: 129,
  typeKey: 'CARE_RESCUE_OTHER',
  name: 'Autre soins et secours',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Glossaire des évènements de livraison
 * @type {{name: string, typeKey: string}}
 */
export const EVENT_DELIVERY_PACKAGE = {
  id: 130,
  typeKey: 'DELIVERY_PACKAGE',
  name: 'Livraison colis',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_DELIVERY_MAIL = {
  id: 131,
  typeKey: 'DELIVERY_MAIL',
  name: 'Livraison courrier',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_DELIVERY_MERCHANDISE = {
  id: 132,
  typeKey: 'DELIVERY_MERCHANDISE',
  name: 'Livraison marchandise',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}
export const EVENT_DELIVERY_OTHER = {
  id: 133,
  typeKey: 'DELIVERY_OTHER',
  name: 'Livraison autre',
  defaultValue: {
    enabled: true,
    customerShow: true,
    notifyAgency: false,
    notifyCustomer: false
  }
}

/**
 * Liste des incidents
 */
export const LISTE_TYPE_INCIDENTS = _.sortBy(
  [
    EVENT_INCIDENT_BREAKING_IN,
    EVENT_INCIDENT_HARDWARE_STATE,
    EVENT_INCIDENT_AGENT_ATTACK,
    EVENT_INCIDENT_PHYSICAL_AGGRESSION,
    EVENT_INCIDENT_THEFT,
    EVENT_INCIDENT_FRAUD,
    EVENT_INCIDENT_VERBAL_AGGRESSION,
    EVENT_INCIDENT_INCIVILITY,
    EVENT_INCIDENT_BURNING,
    EVENT_INCIDENT_MATERIAL,
    EVENT_INCIDENT_WATER_DAMAGED,
    EVENT_INCIDENT_ACCIDENT,
    EVENT_INCIDENT_ELECTRICAL_FAILURE,
    EVENT_INCIDENT_HEART_DISEASE,
    EVENT_INCIDENT_UNCONSCIOUS,
    EVENT_INCIDENT_BURN,
    EVENT_INCIDENT_BLEEDING,
    EVENT_INCIDENT_FALL,
    EVENT_INCIDENT_CHOKING,
    EVENT_INCIDENT_OTHER,
    EVENT_SPECIFIC_CONTROL_DOOR,
    EVENT_SPECIFIC_CONTROL_PORTAL,
    EVENT_SPECIFIC_CONTROL_FENCING,
    EVENT_SPECIFIC_CONTROL_WINDOW,
    EVENT_SPECIFIC_CONTROL_TEMPERATURE,
    EVENT_SPECIFIC_CONTROL_MATERIAL,
    EVENT_SPECIFIC_CONTROL_ELECTRIC,
    EVENT_SPECIFIC_CONTROL_EXTINGUISHER,
    EVENT_SPECIFIC_CONTROL_MACHINE,
    EVENT_SPECIFIC_CONTROL_SHOWCASE,
    EVENT_SPECIFIC_CONTROL_VEHICLE,
    EVENT_SPECIFIC_CONTROL_CHECKOUT,
    EVENT_SPECIFIC_CONTROL_PEOPLE,
    EVENT_SPECIFIC_CONTROL_ROOM,
    EVENT_SPECIFIC_CONTROL_FLOOR,
    EVENT_SPECIFIC_CONTROL_BUILDING,
    EVENT_SPECIFIC_CONTROL_EXTERIOR,
    EVENT_SPECIFIC_CONTROL_ENTRY,
    EVENT_SPECIFIC_CONTROL_EXIT,
    EVENT_SPECIFIC_CONTROL_STOCK,
    EVENT_SPECIFIC_CONTROL_OTHER,
    EVENT_PRESENCE_ENTRY,
    EVENT_PRESENCE_EXIT,
    EVENT_PRESENCE_ON_SITE,
    EVENT_PRESENCE_OTHER,
    EVENT_LOGISTIC_MERCHANDISES_ENTRY,
    EVENT_LOGISTIC_MERCHANDISES_EXIT,
    EVENT_LOGISTIC_KEY,
    EVENT_LOGISTIC_BADGE,
    EVENT_LOGISTIC_LOSS,
    EVENT_LOGISTIC_THEFT,
    EVENT_LOGISTIC_VEHICLE,
    EVENT_LOGISTIC_CLOTHING,
    EVENT_LOGISTIC_TOOLS,
    EVENT_LOGISTIC_OTHER,
    EVENT_CARE_RESCUE_POLICE,
    EVENT_CARE_RESCUE_FIREFIGHTER,
    EVENT_CARE_RESCUE_GENDARME,
    EVENT_CARE_RESCUE_AMBULANCE,
    EVENT_CARE_RESCUE_DOCTOR,
    EVENT_CARE_RESCUE_REINFORCEMENT,
    EVENT_CARE_RESCUE_FIRST_AID,
    EVENT_CARE_RESCUE_OTHER,
    EVENT_DELIVERY_PACKAGE,
    EVENT_DELIVERY_MAIL,
    EVENT_DELIVERY_MERCHANDISE,
    EVENT_DELIVERY_OTHER,
    EVENT_INCIDENT_INTRUSION,
    EVENT_INCIDENT_FREE_ENTRY,
    EVENT_INCIDENT_ALARM_TRIGGERED,
    EVENT_INCIDENT_STONING,
    EVENT_INCIDENT_BREAKING_IN,
    EVENT_INCIDENT_HARDWARE_STATE,
    EVENT_INCIDENT_AGENT_ATTACK,
    EVENT_INCIDENT_PHYSICAL_AGGRESSION,
    EVENT_INCIDENT_THEFT,
    EVENT_INCIDENT_FRAUD,
    EVENT_INCIDENT_INCIVILITY,
    EVENT_INCIDENT_BURNING,
    EVENT_INCIDENT_WATER_DAMAGED,
    EVENT_INCIDENT_ACCIDENT,
    EVENT_INCIDENT_ELECTRICAL_FAILURE
  ],
  'name'
)

/**
 * Liste des alerts par défaut
 * @type {*[]}
 */
export const LISTE_ALERTS = [
  TYPE_SERVICE_FINISH,
  TYPE_SERVICE_LATE,
  TYPE_SERVICE_RESUME,
  TYPE_AGENT_FALL,
  TYPE_AGENT_INACTIVE,
  TYPE_AGENT_EMERGENCY_CALL,
  TYPE_AGENT_LEAVE_PREMISES,
  TYPE_AGENT_RETURN,
  TYPE_SERVICE_ROUND_FINISH,
  ...LISTE_TYPE_INCIDENTS
]
